globalThis.backoffice = globalThis.backoffice || {};

backoffice.ModalEditReminder = (function(superClass)
{
    utils.extend(ModalEditReminder, superClass);

    function ModalEditReminder($html) {
      return ModalEditReminder.__super__.constructor.apply(this, arguments);
    }

    $.extend(ModalEditReminder.prototype, {
      init: function() {
        this.$html.find('.daterange-single').daterangepicker({
          singleDatePicker: true,
          timePicker: true,
          timePicker24Hour: true,
          locale: {
            format: 'DD/MM/YYYY LT'
          }
        });

        ModalEditReminder.__super__.init.apply(this, arguments);
      },
      callbackSuccess: function(data) {
        if(data.response) {
          window.location.href = this.$html.data('redirect-url')
        }

        ModalEditReminder.__super__.callbackSuccess.apply(this, arguments);
      }
    });

    return ModalEditReminder;
})(backoffice.ModalMain);
